<div
    class="logs-signpost-custom"
    *ngIf="trafficLogsSignpostStore.logSelectedSignpostConfigKey$ | async as configKey"
>
    <logs-signpost-custom-waf-latency
        *ngIf="configKey === customTemplates.wafPhaseLatency"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="alerts"></ng-container>
    </logs-signpost-custom-waf-latency>

    <logs-signpost-custom-waf-rule-groups
        *ngIf="configKey === customTemplates.wafRuleGroups"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="alerts"></ng-container>
    </logs-signpost-custom-waf-rule-groups>

    <logs-signpost-custom-groups
        *ngIf="configKey === customTemplates.policy || configKey === customTemplates.ssl"
        [configKey]="configKey"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="alerts"></ng-container>
    </logs-signpost-custom-groups>

    <logs-signpost-custom-significance
        *ngIf="configKey === customTemplates.significance"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="alerts"></ng-container>
    </logs-signpost-custom-significance>

    <logs-signpost-custom-e2e-timing
        *ngIf="configKey === customTemplates.e2eTiming"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="alerts"></ng-container>
    </logs-signpost-custom-e2e-timing>

    <logs-signpost-custom-waf-rule
        *ngIf="configKey === customTemplates.wafRule"
        [poolId]="poolId"
    >
        <ng-container *ngTemplateOutlet="alerts"></ng-container>
    </logs-signpost-custom-waf-rule>
</div>

<ng-template #alerts>
    <ng-content></ng-content>
</ng-template>
